import React from "react";
import { FRAMING_FINISHES } from "../lib/framing";

export const FramingOptionSelector = ({ options = [], selected, onSelect }) => {
  const enabled = options.filter((o) => o.enabled && o.prices);
  if (!enabled.length) return null;
  const keyOf = (o, finish) => `${o.code}__${finish.code}`;
  return (
    <div className="mt-8" data-testid="framing-selector">
      <div className="overline text-neutral-500 mb-3">Acabado · Enmarcación sencilla</div>
      <button
        type="button"
        onClick={() => onSelect(null)}
        className={`w-full text-left border px-4 py-3 mb-2 transition-colors ${!selected ? "border-black bg-neutral-50" : "border-neutral-200 hover:border-neutral-400"}`}
        data-testid="framing-option-none"
      >
        <div className="text-sm font-medium">Solo impresión fine art</div>
        <div className="text-xs text-neutral-500 mt-0.5">Respeta la proporción original de la obra. Para enmarcación especial, consulta talleres asociados.</div>
      </button>
      <div className="space-y-3">
        {enabled.map((o) => (
          <div key={o.code} className="border border-neutral-200 p-3" data-testid={`framing-format-${o.code}`}>
            <div className="flex items-center justify-between gap-3 mb-2">
              <div>
                <div className="font-serif text-lg">Marco {o.frame_label}</div>
                <div className="text-xs text-neutral-500">Impresión {o.print_label} cm · reencuadre aprobado por el artista</div>
              </div>
            </div>
            <div className="grid sm:grid-cols-3 gap-2">
              {FRAMING_FINISHES.map((finish) => {
                const price = o.prices?.[finish.code];
                const active = selected && selected.code === o.code && selected.finish_code === finish.code;
                return (
                  <button
                    key={finish.code}
                    type="button"
                    onClick={() => onSelect({ ...o, finish_code: finish.code, finish_label: finish.label, price })}
                    className={`text-left border px-3 py-2 transition-colors ${active ? "border-black bg-neutral-950 text-white" : "border-neutral-200 hover:border-neutral-500"}`}
                    data-testid={`framing-option-${o.code}-${finish.code}`}
                  >
                    <div className="overline text-[9px] opacity-70">{finish.short}</div>
                    <div className="font-serif text-base mt-1">€{price?.toFixed(2)}</div>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FramingOptionSelector;